<template>
  <div>
    <div class="tags">
      <SjTag theme="1" size="mini">
        display theme 1
      </SjTag>
      <SjTag theme="2" size="small">
        display theme 2
      </SjTag>
      <SjTag theme="3">
        display theme 3
      </SjTag>
      <SjTag theme="4" size="middle">
        display theme 4
      </SjTag>
      <SjTag theme="5" size="large">
        display theme 5
      </SjTag>
    </div>
    <div class="tags">
      <SjTag theme="1" size="mini" type="closeonly" @close="close">
        closeonly theme 1
      </SjTag>
      <SjTag theme="2" size="small" type="closeonly" @close="close">
        closeonly theme 2
      </SjTag>
      <SjTag theme="1" type="closeonly" @close="close">
        closeonly theme 1
      </SjTag>
      <SjTag theme="2" size="middle" type="closeonly" @close="close">
        closeonly theme 2
      </SjTag>
      <SjTag theme="1" size="large" type="closeonly" @close="close">
        closeonly theme 1
      </SjTag>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    close() {
      alert("关闭");
    }
  }
};
</script>

<style scoped lang="less">
.tags {
  > * {
    margin-right: 20px;
  }
}
</style>
